"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function (nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

// import Odometer from "react-odometerjs";
// placeholder for SSR
let Odometer = _ref => {
  let {
    value
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", null, value);
};
let _odometer_import_triggered = false;
const OdometerSsrSafe = props => {
  (0, _react.useEffect)(() => {
    if (_odometer_import_triggered) return;else {
      _odometer_import_triggered = true; // dynamic import of odometer

      Promise.resolve().then(() => _interopRequireWildcard(require("react-odometerjs"))).then(module => {
        Odometer = module.default;
      });
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(Odometer, props);
};
var _default = OdometerSsrSafe;
exports.default = _default;